<template>
  <div v-if="show">
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.course_markup') }}
    </div>
    <div class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <!-- Если есть activeAccount, показываем все валюты динамически -->
        <div
          v-if="hasActiveAccount"
          class="dialog-add-account__form-col dialog-add-account__form-col--big course-percent"
        >
          <div
            v-for="(percent, currency) in value"
            :key="currency"
            class="dialog-add-account__form-item"
          >
            <div class="form-input course-markup" :class="{ 'form-input--full': value }">
              <input
                :value="percent"
                type="text"
                :disabled="disabled"
                @input="handleCurrencyChange(currency, $event.target.value)"
              />
              <span class="form-input__label">{{ currency }}, %</span>
            </div>
          </div>
        </div>
        <!-- Если нет activeAccount, показываем только USD и EUR -->
        <div
          v-else
          class="dialog-add-account__form-col dialog-add-account__form-col--big course-percent"
        >
          <div class="dialog-add-account__form-item">
            <div
              class="form-input course-markup"
              :class="[
                {
                  'form-input--full': 'USD' in value && value['USD'],
                },
              ]"
            >
              <input
                :value="value.USD"
                type="text"
                :disabled="disabled"
                @input="handleCurrencyChange('USD', $event.target.value)"
              />
              <span class="form-input__label"> USD, %</span>
            </div>
          </div>
          <div class="dialog-add-account__form-item">
            <div
              class="form-input course-markup"
              :class="[
                {
                  'form-input--full': 'EUR' in value && value['EUR'],
                },
              ]"
            >
              <input
                :value="value.EUR"
                type="text"
                :disabled="disabled"
                @input="handleCurrencyChange('EUR', $event.target.value)"
              />
              <span class="form-input__label"> EUR, %</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseMarkupInput',
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasActiveAccount: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleCurrencyChange(currency, newValue) {
      const updated = { ...this.value };
      this.$set(updated, currency, newValue);
      this.$emit('input', updated);
    },
  },
  emits: ['input'],
};
</script>
